export default "__VITE_ASSET__DkqQ8_vz__"